import { type ChangeEventHandler } from "react";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Textarea, TextareaProps } from "@/components/ui/textarea";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import FormFieldTooltip from "./FormFieldTooltip";

type FormFieldTextareaPropsType<T extends FieldValues> = Omit<TextareaProps, "form"> & {
  form: UseFormReturn<T, unknown, undefined>;
  placeholder?: string;
  label?: string;
  name: FieldPath<T>;
  description?: string;
  tooltip?: string;
  onChange?: ChangeEventHandler;
  className?: string;
};

function FormFieldTextarea<T extends FieldValues>({
  form,
  description,
  tooltip,
  placeholder,
  label,
  name,
  onChange,
  className,
  ...props
}: FormFieldTextareaPropsType<T>) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel>
            {label}
            {tooltip && <FormFieldTooltip content={tooltip} />}
          </FormLabel>
          <FormControl>
            <Textarea
              placeholder={placeholder}
              {...field}
              onChange={(e) => {
                onChange ? onChange(e) : field.onChange(e);
              }}
              {...props}
            />
          </FormControl>
          <FormDescription>{description}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default FormFieldTextarea;
